itsoftApp.createModule("scrollEffectsSettings", ["scrollEffects"], function () {

    var ScrollEffects = itsoftApp.modules.scrollEffects.ScrollEffect;
    var fadeInElements = document.querySelectorAll(".fadeIn");
    var elementsInvisible = document.querySelectorAll(".js-invisible");

        //анимация fadeIn элементов

    var initAnimation = function () {
        Array.prototype.forEach.call(fadeInElements, function (fadeInElement) {
            new ScrollEffects(fadeInElement, "fadeInShow", "fadeIn");
        });

        Array.prototype.forEach.call(elementsInvisible, function (elementInvisible) {
            new ScrollEffects(elementInvisible, "js-visible", "js-invisible");
        });
    };

    itsoftApp.modules.pageLoad.addEvent(initAnimation);
});